import * as React from 'react';

import { TextMessage } from '../../../../components/TextMessage';
import { useMessageContext } from '../../../../utils/messageContext';
import { useMessageText, useMessageHtmlText } from '../../hooks';
import { trackClickMessage } from '../../tracking';

interface ITextMessageContainerProps {
  htmlText?: string;
}

export const TextMessageContainer: React.FC<ITextMessageContainerProps> = () => {
  const { message, messageId, chatId } = useMessageContext();

  const { isOutcoming, communicationId, offers } = message;

  const offer = offers?.[0];

  const htmlText = useMessageHtmlText(message);

  const text = useMessageText({ message, messageId });

  const onClickMessage = React.useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      if ((e.target as HTMLElement).tagName === 'A') {
        const anchor = e.target as HTMLAnchorElement;
        const messageType = anchor.href.includes('tel') ? 'phone' : 'link';
        const clickText = anchor.dataset.clickText;

        trackClickMessage({
          chatId,
          messageId,
          messageType,
          offerId: offer?.realtyOfferId,
          communicationId,
          clickText,
        });
      }
    },
    // oxlint-disable-next-line react/exhaustive-deps
    [chatId, offer],
  );

  if (!htmlText && !text) {
    return null;
  }

  return (
    <TextMessage
      // oxlint-disable-next-line react/no-danger
      text={htmlText ? <div dangerouslySetInnerHTML={{ __html: htmlText }} /> : text}
      onClick={onClickMessage}
      textColor={isOutcoming ? 'text-inverted-default' : 'text-primary-default'}
    />
  );
};
